exports.checkYourAnswers = function() {
    $('.change-link').click(function () {
        window.dataLayer && dataLayer.push({
            'event': 'event_data',
            'event_data': {
                'event_name': 'change_link_clicked'
            },
        })
    });

    $('input[name="js-enabled"]').val("true");
};
